"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLawIDOrLawRevID = exports.parseLawID = exports.LawIDCabinetOrderEffect = exports.LawIDActCategory = exports.ptnLawID = exports.lawIDTypes = exports.LawIDType = void 0;
const util_1 = require("../util");
const std_1 = require("./std");
// c.f. https://laws.e-gov.go.jp/file/LawIdNamingConvention.pdf
var LawIDType;
(function (LawIDType) {
    LawIDType["Constitution"] = "Constitution";
    LawIDType["Act"] = "Act";
    LawIDType["CabinetOrder"] = "CabinetOrder";
    LawIDType["ImperialOrder"] = "ImperialOrder";
    LawIDType["DajokanFukoku"] = "DajokanFukoku";
    LawIDType["DajokanTasshi"] = "DajokanTasshi";
    LawIDType["DajokanFutatsu"] = "DajokanFutatsu";
    LawIDType["MinisterialOrdinance"] = "MinisterialOrdinance";
    LawIDType["Jinji"] = "Jinji";
    LawIDType["Rule"] = "Rule";
    LawIDType["PrimeMinisterDecision"] = "PrimeMinisterDecision";
})(LawIDType || (exports.LawIDType = LawIDType = {}));
exports.lawIDTypes = Object.values(LawIDType);
exports.ptnLawID = {
    // e.g. `321CONSTITUTION` (昭和二十一年憲法)
    [LawIDType.Constitution]: "\
(?<era>\\d)\
(?<year>\\d{2})\
CONSTITUTION\
",
    // e.g. `335AC0000000105` (昭和三十五年法律第百五号)
    [LawIDType.Act]: "\
(?<era>\\d)\
(?<year>\\d{2})\
AC\
(?<category>\\d{7})\
(?<num>\\d{3})\
",
    // e.g. `415CO0000000263` (平成十五年政令第二百六十三号)
    [LawIDType.CabinetOrder]: "\
(?<era>\\d)\
(?<year>\\d{2})\
CO\
(?<category>\\d{7})\
(?<num>\\d{3})\
",
    // e.g. `318IO0000000618` (昭和十八年勅令第六百十八号)
    [LawIDType.ImperialOrder]: "\
(?<era>\\d)\
(?<year>\\d{2})\
IO\
(?<category>\\d{7})\
(?<num>\\d{3})\
",
    // e.g. `105DF0000000337` (明治五年太政官布告第三百三十七号)
    [LawIDType.DajokanFukoku]: "\
(?<era>\\d)\
(?<year>\\d{2})\
DF\
(?<category>\\d{7})\
(?<num>\\d{3})\
",
    // e.g. `110DT0000000097` (明治十年太政官達第九十七号)
    [LawIDType.DajokanTasshi]: "\
(?<era>\\d)\
(?<year>\\d{2})\
DT\
(?<category>\\d{7})\
(?<num>\\d{3})\
",
    // e.g. `106DH0000000016` (明治六年太政官布達第十六号)
    [LawIDType.DajokanFutatsu]: "\
(?<era>\\d)\
(?<year>\\d{2})\
DH\
(?<category>\\d{7})\
(?<num>\\d{3})\
",
    // e.g. `427M60001080001` (平成二十七年文部科学省・環境省令第一号)
    [LawIDType.MinisterialOrdinance]: "\
(?<era>\\d)\
(?<year>\\d{2})\
M\
(?<category>[0-9a-fA-F]{8})\
(?<num>\\d{3})\
",
    // e.g. `333RJNJ09024000` (昭和三十三年人事院規則九―二四), `427RJNJ09017142` (平成二十七年人事院規則九―一七―一四二)
    [LawIDType.Jinji]: "\
(?<era>\\d)\
(?<year>\\d{2})\
R\
JNJ\
(?<num1>\\d{2})\
(?<num2>\\d{3})\
(?<num3>\\d{3})\
",
    // e.g. `322R00000001001` (昭和二十二年会計検査院規則第一号)
    [LawIDType.Rule]: "\
(?<era>\\d)\
(?<year>\\d{2})\
R\
(?<category>[0-9a-fA-F]{8})\
(?<num>\\d{3})\
",
    // e.g. `427RPMD10100000` ( 平成二十七年十月十日内閣総理大臣決定)
    [LawIDType.PrimeMinisterDecision]: "\
(?<era>\\d)\
(?<year>\\d{2})\
R\
PMD\
(?<date>[0-9a-fA-F]{4})\
(?<num>\\d{4})\
",
};
const reLawID = Object.fromEntries(Object.entries(exports.ptnLawID).map(([key, value]) => [key, new RegExp(`^${value}$`)]));
const eraNumToEra = {
    "1": std_1.Era.Meiji,
    "2": std_1.Era.Taisho,
    "3": std_1.Era.Showa,
    "4": std_1.Era.Heisei,
    "5": std_1.Era.Reiwa,
};
var LawIDActCategory;
(function (LawIDActCategory) {
    LawIDActCategory["Cabinet"] = "0000000";
    LawIDActCategory["HouseOfRepresentative"] = "1000000";
    LawIDActCategory["HouseOfCouncillors"] = "0100000";
})(LawIDActCategory || (exports.LawIDActCategory = LawIDActCategory = {}));
var LawIDCabinetOrderEffect;
(function (LawIDCabinetOrderEffect) {
    LawIDCabinetOrderEffect["CabinetOrder"] = "0000000";
    LawIDCabinetOrderEffect["Act"] = "1000000";
})(LawIDCabinetOrderEffect || (exports.LawIDCabinetOrderEffect = LawIDCabinetOrderEffect = {}));
const parseLawID = (text) => {
    for (const type of exports.lawIDTypes) {
        const re = reLawID[type];
        const m = re.exec(text);
        if (!m || !m.groups)
            continue;
        if (type === LawIDType.MinisterialOrdinance) {
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
                category: m.groups.category,
                rawNum: m.groups.num,
                num: m.groups.num.replace(/^(?:0(?!$))+/, ""),
            };
        }
        else if (type === LawIDType.Act) {
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
                category: m.groups.category,
                rawNum: m.groups.num,
                num: m.groups.num.replace(/^(?:0(?!$))+/, ""),
            };
        }
        else if (type === LawIDType.CabinetOrder || type === LawIDType.ImperialOrder || type === LawIDType.DajokanFukoku || type === LawIDType.DajokanTasshi || type === LawIDType.DajokanFutatsu) {
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
                category: m.groups.category,
                rawNum: m.groups.num,
                num: m.groups.num.replace(/^(?:0(?!$))+/, ""),
            };
        }
        else if (type === LawIDType.Jinji) {
            const numParts = [
                m.groups.num1.replace(/^(?:0(?!$))+/, ""),
                m.groups.num2.replace(/^(?:0(?!$))+/, ""),
            ];
            if (m.groups.num3 !== "000") {
                numParts.push(m.groups.num3.replace(/^(?:0(?!$))+/, ""));
            }
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
                rawNumPart1: m.groups.num1,
                rawNumPart2: m.groups.num2,
                rawNumPart3: m.groups.num3,
                num: numParts.join("_"),
            };
        }
        else if (type === LawIDType.Rule) {
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
                category: m.groups.category,
                rawNum: m.groups.num,
                num: m.groups.num.replace(/^(?:0(?!$))+/, ""),
            };
        }
        else if (type === LawIDType.PrimeMinisterDecision) {
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
                date: m.groups.date,
                rawNum: m.groups.num,
                num: m.groups.num.replace(/^0+/, ""),
            };
        }
        else if (type === LawIDType.Constitution) {
            return {
                text,
                type,
                era: eraNumToEra[m.groups.era],
                year: m.groups.year,
            };
        }
        else {
            throw (0, util_1.assertNever)(type);
        }
    }
    return null;
};
exports.parseLawID = parseLawID;
const parseLawIDOrLawRevID = (text) => {
    const parts = text.split("_");
    if (parts.length === 1) {
        return (0, exports.parseLawID)(parts[0]);
    }
    else if (parts.length === 3) {
        const law = (0, exports.parseLawID)(parts[0]);
        if (!law)
            return null;
        const date = parts[1];
        if (!/^\d{8}$/.test(date))
            return null;
        const amendLaw = (0, exports.parseLawID)(parts[2]);
        if (!amendLaw && (parts[2] !== "000000000000000"))
            return null;
        return { law, date, amendLaw };
    }
    else {
        return null;
    }
};
exports.parseLawIDOrLawRevID = parseLawIDOrLawRevID;
//# sourceMappingURL=lawID.js.map